import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import Rejected from "../../../../images/rejected.png";

//Interface
import { TextArr, ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  loading,
  selected,
  toastMessage,
  onBack,
  setSelected,
  cancelPickupHandler,
  resetToastMessage,
}) => {
  return (
    <CustomBody resetToast={resetToastMessage} toastMessage={toastMessage} loading={loading}>
      <div className="request-cancel-pickup-body">
        <KickImage src={Rejected} alt="rejected" className="rejected-icon" />
        <p className="title">Cancel Pick-up Request</p>
        <p className="sub-title">Are you sure want to cancel this pick-up request?</p>

        {
          TextArr.map((text, idx) => {
            const lastItem = idx === TextArr.length - 1;
            const selectedCard = selected === text;
            return (<div onClick={() => setSelected(text)} key={idx} className={`cancel-text-card ${selectedCard ? "active" : ""} ${lastItem ? "last-item" : ""}`}>
              <span>{text}</span>
            </div>)
          })
        }

        <div className="button-wrapper">
          <CustomButton
            className="back-btn"
            text={"Back"}
            disabled={false}
            onClick={() => onBack()}
          />
          <CustomButton
            text={"Submit"}
            disabled={selected === null}
            onClick={() => cancelPickupHandler()}
          />
        </div>
      </div>
    </CustomBody>
  )
}
export default Component;